import { getUserAgent } from "./userAgent";
import { includes } from "lodash/fp";

export const PLATFORMS = [
  "android-app",
  "ios-app",
  "amadeus-travel-android-app",
  "amadeus-travel-ios-app",
];

export const isPlatform = () => {
  const ua = getUserAgent();
  if (!ua || typeof window === "undefined") return false;

  const search = new URLSearchParams(window.location.search);

  // Check URL parameters first
  let isApp =
    !!search.get("platform") && includes(search.get("platform"), PLATFORMS);

  // Then check local storage
  try {
    const platformStorage = localStorage.getItem("comvel-platform");
    if (platformStorage && includes(platformStorage, PLATFORMS)) {
      isApp = true;
    }
  } catch (e) {
    console.warn(e);
  }

  return isApp;
};
